"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation updateEventOrSeasonFee($orgId: String,$eventId: String,$seasonId: String, $fee: FeeInput!) {
    updateEventOrSeasonFee(orgId: $orgId,eventId: $eventId,seasonId: $seasonId, fee: $fee) {
      _id
      name
      orgId
      eventId
      seasonId
      type
      value
      appliedTo
      appliedBy
      minAppliedToPrice
      maxAppliedToPrice
      filters
      paymentMethods
      createdBy
      createdAt
      updatedBy
      updatedAt
      disabled
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=updateEventOrSeasonFee.mutation.js.map